import { render, staticRenderFns } from "./MyDocumentsPage.vue?vue&type=template&id=71319367"
import script from "./MyDocumentsPage.vue?vue&type=script&lang=ts"
export * from "./MyDocumentsPage.vue?vue&type=script&lang=ts"
import style0 from "./MyDocumentsPage.vue?vue&type=style&index=0&id=71319367&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports